<template>
	<register-coworker-form :form-data="formData"
		v-on:register="register"
		v-on:cancel="cancel"/>
</template>

<script>
	import RegisterCoworkerForm from "./components/RegisterCoworkerForm";
	import {encoder} from "@/utils/encodeHelper";
  import {UserRegister} from "@/api/generated/UserRegister";

	export default {
    name: "RegisterCoworkerView",

		components: {RegisterCoworkerForm},

		data() {
			return {
				formData: {
					name: "",
					surname: "",
					phoneNumber: "",
					email: "",
					subBidderType: "COWORKER"
				},
			};
		},

		provide() {
			return {parentValidator: this.$validator};
		},

		methods: {
			register(formData, scope) {
				this.$validator.validateAll(scope).then(valid => {
					if (!valid) {
						return;
					}
          UserRegister.getValidateUserEmailUniqueness(this, encoder.encodeUrlParam(this.formData.email), successResponse => {
							if (successResponse.unique === false) {
								this.vErrors.add({
									field: 'email',
									msg: 'Nie można zarejestrować użytkownika o takim adresie email',
									scope: 'scope'
								});
							} else {
                UserRegister.postRegisterSubBidder(this, this.formData, response => {
									if (response !== undefined && response.status === "OK") {
										this.$router.push("../app/sub-bidders");
									} else {
										this.$router.push("/error");
									}
								});
							}
						}, errorResponse => {
            let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
                ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
                : "Wystąpił błąd podczas walidacji adresu e-mail";
            this.$messagesBus.$emit("error", errorMessage, errorResponse);
          });
				});
			},

			cancel() {
				window.location.replace("../app/sub-bidders");
			},
		},
	};
</script>
